import { AsyncPipe } from '@angular/common';
import { Component, computed, inject, signal } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@core/pipes/translate.pipe';
import { TranslationService } from '@core/services/translation.service';
import { WorkspaceService } from '@core/services/workspace.service';
import { AuthService } from '@modules/auth/services/auth.service';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    InputTextModule,
    ButtonModule,
    RouterLink,
    SelectModule,
    FormsModule,
    AsyncPipe,
    TranslatePipe,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class LoginComponent {
  loginForm!: FormGroup;
  builder = inject(FormBuilder);
  router = inject(Router);
  showPassword = signal<boolean>(false);

  // Computed signals
  passwordInputType = computed(() => (this.showPassword() ? 'text' : 'password'));
  eyeIcon = computed(() => (this.showPassword() ? 'eye-slash' : 'eye'));

  constructor(
    public authService: AuthService,
    public translateService: TranslationService,
    private workspaceService: WorkspaceService,
    private messageService: MessageService,
  ) {
    this.loginForm = this.builder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required]],
    });
  }

  switchLang(lang: string) {
    this.translateService.setLanguage(lang);
  }

  onLogin() {
    if (!this.loginForm.valid) {
      this.loginForm.markAllAsTouched();
      return;
    }

    // this.errorText = '';
    this.authService.login(this.loginForm.value).subscribe({
      next: (res) => {
        if (res && res['success']) {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'Login Successfully',
          });
          this.router.navigate(['/dashboard']);
          this.workspaceService.fetchAndStoreWorkspaceDetails().subscribe({
            error: (workspaceErr) => {
              console.warn('Failed to preload workspace details after login', workspaceErr);
            },
          });
        }
      },
      error: (err) => {
        console.log('err', err);
        // this.errorText = err.error.error.description || 'Invalid Credentials';
      },
    });
  }

  onPasswordShow() {
    this.showPassword.update((value) => !value);
  }
}
